export default function changeWaLocal(language) {
    if (process.env.PROJECT_FOLDER === 'itpiry') {
        if (language) {
            utag_data.wa_local = language
        }
        else utag_data.wa_local = 'br-pt'
    }
}